document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".dw-accordion").forEach((accordion) => {
    const summary = accordion.querySelector(".dw-accordion__summary");
    const content = accordion.querySelector(".dw-accordion__content");
    if (!summary || !content) return;

    let isOpen = accordion.hasAttribute("open");
    let isAnimating = false;

    content.style.overflow = "hidden";
    content.style.boxSizing = "border-box";
    content.style.height = isOpen ? "auto" : "0px";
    content.style.opacity = isOpen ? "1" : "0";
    summary.setAttribute("aria-expanded", String(isOpen));

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (isAnimating) return;
      isOpen ? closeAccordion() : openAccordion();
    });

    content.addEventListener("click", () => {
      if (!isAnimating && isOpen) closeAccordion();
    });

    function openAccordion() {
      isAnimating = true;
      isOpen = true;
      accordion.open = true;
      summary.setAttribute("aria-expanded", "true");
      content.style.height = "0px";
      content.style.opacity = "0";
      const endHeight = content.scrollHeight;
      const animation = content.animate(
        [
          { height: "0px", opacity: 0 },
          { height: `${endHeight}px`, opacity: 1 }
        ],
        { duration: 300, easing: "ease" }
      );
      animation.onfinish = () => {
        content.style.height = "auto";
        content.style.opacity = "1";
        isAnimating = false;
      };
    }

    function closeAccordion() {
      isAnimating = true;
      isOpen = false;
      summary.setAttribute("aria-expanded", "false");
      const startHeight = content.scrollHeight;
      const animation = content.animate(
        [
          { height: `${startHeight}px`, opacity: 1 },
          { height: "0px", opacity: 0 }
        ],
        { duration: 400, easing: "ease" }
      );
      animation.onfinish = () => {
        content.style.height = "0px";
        content.style.opacity = "0";
        accordion.open = false;
        isAnimating = false;
      };
    }
  });
});